import { component$ } from "@builder.io/qwik";
import { useDocumentHead } from "@builder.io/qwik-city";
import favicon96 from "./favicon-96.png?no-inline";
import faviconICO from "./favicon.ico?no-inline";
import appleTouchIcon180 from "./apple-touch-icon-180.png?no-inline";
import { TPScriptsManager } from "../features/third-part-scripts";
import {
  useGoogleAnalytics,
  useNielsenApid,
  useNielsenHashedPath,
} from "~/routes/layout";
import { getDefaultHeadMeta } from "./default-meta";

/**
 * The RouterHead component is placed inside of the document `<head>` element.
 */
export const RouterHead = component$(() => {
  const head = useDocumentHead();
  const googleAnalytics = useGoogleAnalytics();
  const nlsnApid = useNielsenApid();
  const nielsenHashedPath = useNielsenHashedPath();

  return (
    <>
      <title>{head.title}</title>

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      <link rel="icon" type="image/png" href={favicon96} sizes="96x96" />
      <link rel="icon" href={faviconICO} />
      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon180} />

      {getDefaultHeadMeta(head.meta).map((m) => (
        <meta key={m.key ?? m.name ?? m.property} {...m} />
      ))}

      <link
        rel="alternate"
        type="application/rss+xml"
        title="Super Guida TV » Feed"
        href="https://www.superguidatv.it/feed/"
      />

      {head.meta.map((m) => (
        <meta key={m.key} {...m} />
      ))}

      {head.links.map((l) => (
        <link key={l.key} {...l} />
      ))}

      {head.styles.map((s) => (
        <style
          key={s.key}
          {...s.props}
          {...(s.props?.dangerouslySetInnerHTML
            ? {}
            : { dangerouslySetInnerHTML: s.style })}
        />
      ))}

      {head.scripts.map((s) => (
        <script
          key={s.key}
          {...s.props}
          {...(s.props?.dangerouslySetInnerHTML
            ? {}
            : { dangerouslySetInnerHTML: s.script })}
        />
      ))}

      <TPScriptsManager.PartyTownInjector />
      <TPScriptsManager.GoogleAnalytics
        gaId={googleAnalytics.value.gaId}
        gaDebug={googleAnalytics.value.gaDebug}
      />
      <TPScriptsManager.Nielsen
        nlsnApid={nlsnApid.value}
        assetId={nielsenHashedPath.value}
      />
    </>
  );
});
